import { IsEmail, Length } from 'class-validator';

export class NewsletterSubscribeModel {
  @Length(6, 128)
  @IsEmail()
  public email: string;

  constructor(email: string) {
    this.email = email;
  }
}
